module.exports = __webpack_public_path__ + "assets/img/hcpimg2.a4be9df6.png";